import { all, fork, takeEvery } from 'redux-saga/effects';
import {
  LOAD_CREDENTIALS,
  LOAD_CREDENTIAL_GROUPS,
  ADD_TO_FAVORITE,
  REMOVE_FROM_FAVORITE,
  UPDATE_CREDENTIAL,
  DELETE_CREDENTIAL,
  UPDATE_CREDENTIAL_GROUP,
  DELETE_CREDENTIAL_GROUP,
  LOAD_PROJECTS_NAME,
  LOAD_PROJECT_CREDENTIALS,
  UPDATE_PROJECT_CREDENTIAL,
  CHECK_CREDENTIAL_PASSWORD,
  LOAD_CREDENTIAL_FIELDS,
} from 'constants/ActionTypes';
import { loadEntities, updateEntity, deleteEntity } from 'helpers/utilHelpers';

export function* loadProjectsName() {
  yield takeEvery(LOAD_PROJECTS_NAME, loadEntities);
}

export function* loadCredentials() {
  yield takeEvery(LOAD_CREDENTIALS, loadEntities);
}

export function* loadCredentialGroups() {
  yield takeEvery(LOAD_CREDENTIAL_GROUPS, loadEntities);
}

export function* addToFavorite() {
  yield takeEvery(ADD_TO_FAVORITE, updateEntity);
}

export function* checkCredentialPassword() {
  yield takeEvery(CHECK_CREDENTIAL_PASSWORD, updateEntity);
}

export function* loadCredentialFields() {
  yield takeEvery(LOAD_CREDENTIAL_FIELDS, loadEntities);
}

export function* removeFromFavorite() {
  yield takeEvery(REMOVE_FROM_FAVORITE, deleteEntity);
}

export function* updateCredential() {
  yield takeEvery(UPDATE_CREDENTIAL, updateEntity);
}

export function* removeCredential() {
  yield takeEvery(DELETE_CREDENTIAL, deleteEntity);
}

export function* updateGroup() {
  yield takeEvery(UPDATE_CREDENTIAL_GROUP, updateEntity);
}

export function* removeGroup() {
  yield takeEvery(DELETE_CREDENTIAL_GROUP, deleteEntity);
}

export function* loadProjectCredentials() {
  yield takeEvery(LOAD_PROJECT_CREDENTIALS, loadEntities);
}

function* updateProjectCredential() {
  yield takeEvery(UPDATE_PROJECT_CREDENTIAL, updateEntity);
}

export default function* rootSaga() {
  yield all([
    fork(updateProjectCredential),
    fork(loadProjectsName),
    fork(loadProjectCredentials),
    fork(removeGroup),
    fork(updateGroup),
    fork(removeCredential),
    fork(updateCredential),
    fork(loadCredentials),
    fork(loadCredentialGroups),
    fork(addToFavorite),
    fork(removeFromFavorite),
    fork(checkCredentialPassword),
    fork(loadCredentialFields),
  ]);
}
